import styled from 'styled-components';
import Select from 'antd/es/select';
import Tabs from 'antd/es/tabs';
import { Popover } from 'react-tiny-popover';

import Button from '@components/Button';
export const StyledGuestPopover = styled(Popover)``;

export const GuestContentWrapper = styled.div`
  position: relative;

  & > div {
    height: 100%;
  }
`;

export const GuestContent = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 20px 95px 20px;
  transition: max-height 0.3s ease-out;
  height: auto;
  max-height: 600px;
  .setur-tabs-nav-add {
    display: none;
  }

  .setur-tabs-card > .setur-tabs-nav .setur-tabs-tab {
    padding: 0 0 3px 0;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid transparent;
  }

  .setur-tabs-card > .setur-tabs-nav .setur-tabs-tab:not(:last-of-type) {
    height: 25px;
    margin-right: 15px;
    box-sizing: border-box;
  }
  .setur-tabs-tab-with-remove {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .setur-tabs-tab-remove {
    display: flex;
    align-items: center;
    margin: 0 0 0 6px;
    padding: 0;
  }

  .setur-tabs-tab-active {
    border-bottom: 2px solid ${({ theme }) => theme.palette.primaryBrand} !important;
  }
`;

export const GuestTabs = styled(Tabs)``;

export const AddNewRoomBox = styled.div`
  height: 80px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

export const AddNewRoomButton = styled(Button)``;

export const RoomButton = styled(Button)``;

export const AddNewRoomButtonText = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-top: -2px;
`;

export const ApplyButton = styled(Button)`
  width: 135px;
`;

export const StyledListingGuestRoom = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  padding: 8px 0px;

  .responsive-room-delete-box {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
  }

  &:last-of-type {
    display: block;
  }
`;

export const GuestRoomBlock = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GuestRoomInfo = styled.div`
  display: flex;
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
  }
`;

export const GuestRoomText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GuestRoomTitle = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const GuestRoomSubtitle = styled.span`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const GuestScrollWrapper = styled.div<{ isOverflow?: boolean }>`
  height: auto;
  padding-right: 12px;
  overflow-y: ${({ isOverflow }) => (isOverflow ? 'scroll' : 'hidden')};
  margin-right: ${({ isOverflow }) => (!isOverflow ? '5px' : '0')};
  padding-bottom: 20px;
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;

    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
  & > div {
    margin-bottom: 10px;
  }

  & > div:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding: 0;
  }
`;

export const GuestChildAgePicker = styled.div<{ isSingleLine: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const SearchGuestItem = styled.div`
  width: auto;
  height: auto;
  background-color: ${({ theme }) => theme.palette.white};
  user-select: none;
  padding: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 20;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const SearchGuestItemContent = styled.div``;
export const SearchGuestItemTextWrapper = styled.div`
  flex: 1;
  margin-left: 15px;
`;

export const SearchGuestIconWrapper = styled.div`
  position: absolute;
  top: 52.5%;
  right: 20px;
  transform: translateY(-50%);
`;
export const SearchGuestItemLabel = styled.span`
  height: 20px;
  opacity: 0.5;
  font-size: 12px;
  font-weight: bold;
  text-overflow: ellipsis;
`;

export const SearchGuestItemText = styled.span`
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: relative;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SelectStyled = styled(Select)`
  border-bottom: 2px solid ${(props) => props.theme.palette.primaryBrand};
  width: 50%;
  margin-bottom: 1rem;
`;

export const SelectOptionStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
